import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useDispatch } from "react-redux";
import { resetFormState } from "../../../../slices/common/reducer";
import { changeActiveTab } from "../../../../slices/org/organizationSlice";
import OrgMapping from "./OrgMapping";
import Details from "./Details";

const SelectedOrganization = () => {
  const dispatch =useDispatch()
  const tabs = useSelector((state) => state.organization.selectedOrganization.tabs);
  const activeTab = useSelector(
    (state) => state.organization.selectedOrganization.activeTab
  );
  const formState = useSelector((state) => state.common.formRendererState);

  const data = useSelector(
    (state) => state.organization.selectedOrganization.detailsData
  );


  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(changeActiveTab("details"));
    };
  }, [dispatch]);

  

  const breadcrumbItems = [
    { title: "Org", link: "" },
    { title: "Organization", link: "/org/org" },
    { title: `${data.code}`, link: "/org/org/update" },
  ];

  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card className="details-wrapper">
          <CardHeader>
            <SelectedTab
              tabs={tabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
            />
          </CardHeader>
          <CardBody>
            {/* <div className="selected-tab-bottom-content"> */}
              {activeTab === "details" && <Details />}
              {activeTab === "org_mapping" && <OrgMapping />}
            {/* </div> */}
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default SelectedOrganization;
